module.exports = __webpack_public_path__ + "img/jg01-7546ae.jpg";